import { Injectable } from '@angular/core';

export interface INewRelicConfig {
  accountId: string;
  customerId: string;
  environmentId: string;
  enabled: boolean;
  version: string;
}

@Injectable()
export class NewRelicConfig implements INewRelicConfig {
  accountId!: INewRelicConfig['accountId'];
  customerId!: INewRelicConfig['customerId'];
  environmentId!: INewRelicConfig['environmentId'];
  enabled!: INewRelicConfig['enabled'];
  version!: INewRelicConfig['version'];
}
